import { styled } from '@nexelem/deprecated-theme';
import { IconComponentProps } from './IconTypes';

export const IconWrapper = styled('button')<Pick<IconComponentProps, 'onClick'>>(({ disabled }) => {
  return {
    all: 'unset',
    outline: 'inherit',
    cursor: 'pointer',
  };
});
